import * as QueryString from "querystringify";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import { EmailForm, PasswordForm } from "./components";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as M from "../../../models";
import { AppState } from "../../../store";
import * as AuthHelper from "../../../utils/AuthHelper";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    clientId: state.auth.clientId,
    clientSecret: state.auth.clientSecret,
    isLoggedIn: (state.auth.data)
        ? state.auth.data.hasUserRecord
        : false,
    userHasAdminRole: AuthHelper.isAdminUser(state.auth.accessToken, state.auth.refreshToken),
    user: state.auth.data ? state.auth.data : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    onAuthSuccess: (accessToken: string, refreshToken: string) => {
        dispatch(Actions.Auth.postAuthorize(accessToken, refreshToken));
    },
});

type OwnProps = RouteComponentProps<{
    returnUrl?: string;
}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    clientId: string;
    clientSecret: string;
    isLoggedIn: boolean;
    userHasAdminRole: boolean;
    user: M.Auth.AuthTokenData | undefined;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    onAuthSuccess: (accessToken: string, refreshToken: string) => void;
};

interface OwnState {
    checkedUser?: M.User.BasicProfile;
}

class SignInForm extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidMount() {
        if (this.props.isLoggedIn) {
            // already logged in, redirect to where user wanted to go
            this.props.goto(this.getRedirectUrl());
        }
    }

    public componentDidUpdate() {
        if (this.props.isLoggedIn) {
            this.props.goto(this.getRedirectUrl());
        }
    }

    public componentWillMount() {
    }

    public componentWillUnmount() {
    }

    public render() {
        const collTimeout = 125;
        const userChecked = this.state.checkedUser !== undefined;

        return <Comp.Page.SignInPage>
            <BS.Collapse in={!userChecked} timeout={collTimeout}>
                <div>
                    <EmailForm
                        onSuccess={(user) => this.onEmailSuccess(user)}
                        returnUrl={this.getRedirectUrl()}
                        user={this.state.checkedUser}
                    />
                </div>
            </BS.Collapse>

            <BS.Collapse in={userChecked} timeout={collTimeout}>
                <div>
                    <PasswordForm
                        onSuccess={(accessToken, refreshToken) => this.onPasswordVerified(accessToken, refreshToken)}
                        onUserChange={() => this.onUserChange()}
                        returnUrl={this.getRedirectUrl()}
                        user={this.state.checkedUser}
                    />
                </div>
            </BS.Collapse>
        </Comp.Page.SignInPage>;
    }

    private getRedirectUrl(): string {
        const queryString = QueryString.parse(this.props.location.search);
        let returnUrl = this.props.userHasAdminRole
            ? Paths.Admin.Landing
            : Paths.Home;

        if (queryString["returnUrl"])
            returnUrl = decodeURIComponent(queryString["returnUrl"]);

        // Custom check for planstone redirect:
        // If planstone, add legacy member GUID as uid param to returnUrl
        if (returnUrl && returnUrl.indexOf("planion") > -1) {
            let uid: string | undefined;
            if (this.state.checkedUser)
                uid = this.state.checkedUser.legacyMemberGuid || undefined;
            else if (this.props.user) {
                uid = this.props.user.legacyMemberGuid;
            }

            if (uid)
                returnUrl = returnUrl + "&uid=" + uid;
        }

        return returnUrl;
    }

    private onEmailSuccess(user: M.User.BasicProfile) {
        this.setState({ ...this.state, checkedUser: user });
    }

    private onUserChange() {
        this.setState({ ...this.state, checkedUser: undefined });
    }

    private onPasswordVerified(accessToken: string, refreshToken: string) {
        this.props.onAuthSuccess(accessToken, refreshToken);
    }
}

export const SignIn: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(SignInForm) as any);



// WEBPACK FOOTER //
// ./src/containers/account/signin/Signin.tsx